import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import styled from "styled-components";
import { ConfigProvider, Button, Icon, Table, message } from "antd";
import { FormattedMessage, useIntl } from "react-intl";

import Axios from "../util/request";
import DeleteAppConfirm from "../components/ManageApp/DeleteAppConfirm";
import NewAppModal from "../components/ManageApp/NewApp/NewAppModal";

function Manage(props) {
  const [dataSource, setDataSource] = useState(
    JSON.parse(localStorage.getItem("ticktick-developer-appdata"))
  );
  // NewAppModal Props 参数
  const [NewAppProps, setNewAppProps] = useState({
    visible: false,
  });
  const [loading, setLoading] = useState(false);
  const Intl = useIntl();
  const columns = [
    {
      title: <FormattedMessage id="manageApp_newApp" />,
      dataIndex: "appName",
      key: "appName",
      width: "100px",
      render: (text, record) => <LongCell>{text}</LongCell>,
    },
    {
      title: <FormattedMessage id="manageApp_desctiption" />,
      dataIndex: "description",
      key: "description",
      width: "200px",
      render: (text, record) => <LongCell>{text}</LongCell>,
    },
    {
      title: <FormattedMessage id="manageApp_action" />,
      dataIndex: "action",
      width: "100px",
      render: (text, record) =>
        dataSource.length >= 1 ? (
          <>
            <ActionButton type="link">
              <Link to={`/manage/${record.id}`}>
                {Intl.formatMessage({ id: "manageApp_edit" })}
              </Link>
            </ActionButton>
            <CrossLine />
            <DeleteAppConfirm
              title={Intl.formatMessage({ id: "deleteApp_title" })}
              content={Intl.formatMessage({ id: "deleteApp_content" })}
              delete={Intl.formatMessage({ id: "deleteApp_delete" })}
              onOk={() => handleDelete(record.id)}
            />
          </>
        ) : null,
    },
  ];
  const customizeRenderEmpty = () => (
    <div style={{ overflow: "hidden" }}>
      <p style={{ float: "left", margin: 0, color: "rgba(0,0,0,0.65)" }}>
        <FormattedMessage id="manageApp_noAppTip" />
      </p>
    </div>
  );
  //删除 App
  const handleDelete = (id) => {
    Axios.delete(`/api/v1/oauthapp/${id}`)
      .then((res) => {
        const newDataSource = [...dataSource];
        setDataSource(newDataSource.filter((item) => item.id !== id));
        return true;
      })
      .catch((err) => {
        message.error(Intl.formatMessage({ id: "message_deleteFailed" }));
        return false;
      });
  };
  // 添加 App
  const handleCreate = (data) => {
    const newData = [data];
    setDataSource(newData.concat([...dataSource]));
    setNewAppProps({ ...NewAppProps, visible: false });
  };
  // 获取所有 App
  useEffect(() => {
    setLoading(true);
    Axios.get("/api/v1/oauthapp")
      .then((res) => {
        setDataSource(res.data);
      })
      .catch((err) => {
        if (err.code === "401") {
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  //
  useEffect(() => {
    localStorage.setItem(
      "ticktick-developer-appdata",
      JSON.stringify(dataSource)
    );
  }, [dataSource]);
  return (
    <ManageWrapper>
      <TopArea>
        <Title>
          <FormattedMessage id="manageApp_title" />
        </Title>
        <AddButton
          type="primary"
          onClick={() => {
            setNewAppProps({ ...NewAppProps, visible: true });
          }}
        >
          <FormattedMessage id="newApp_title" />
        </AddButton>
      </TopArea>
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <AppList
          dataSource={dataSource}
          columns={columns}
          loading={loading}
          rowKey="id"
          bordered={false}
          rowClassName={(record, index) =>
            index % 2 === 1 ? "customRow" : "customRow customRowDark"
          }
          onRow={(record) => {
            return {
              onClick: (event) => {
                props.history.push(`/manage/${record.id}`);
              }, // 点击行
            };
          }}
          pagination={false}
        />
      </ConfigProvider>
      <NewAppModal
        {...NewAppProps}
        onCancel={() => {
          setNewAppProps({ ...NewAppProps, visible: false });
        }}
        onCreate={handleCreate}
      />
    </ManageWrapper>
  );
}

export default withRouter(Manage);

const ManageWrapper = styled.div`
  max-width: 1080px;
  margin: 33px auto 0;
  @media (max-width: 1080px) {
    padding: 0 50px;
  }
  @media (max-width: 480px) {
    padding: 0 20px;
  }
`;

const TopArea = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Title = styled.h1`
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
  margin: 0;
`;

const AddButton = styled(Button)`
  width: 108px;
`;

const AppList = styled(Table)`
  margin-top: 34px;
`;

const ActionButton = styled(Button)`
  padding: 0;
  font-size: 14px;
  line-height: 22px;
`;

const CrossLine = styled.hr`
  margin: 0 14px;
  display: inline;
  border: 0.5px solid rgba(0, 0, 0, 0.09);
  @media (max-width: 700px) {
    display: none;
  }
`;

const LongCell = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-word;
  word-break: break-all;
`;
